import { render, staticRenderFns } from "./MatterTypeView.vue?vue&type=template&id=ba0d4646&scoped=true"
import script from "./MatterTypeView.vue?vue&type=script&lang=js"
export * from "./MatterTypeView.vue?vue&type=script&lang=js"
import style0 from "./MatterTypeView.vue?vue&type=style&index=0&id=ba0d4646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0d4646",
  null
  
)

export default component.exports